import { render, staticRenderFns } from "./DashboardSlideshow.vue?vue&type=template&id=72a99711&scoped=true&"
import script from "./DashboardSlideshow.vue?vue&type=script&lang=js&"
export * from "./DashboardSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSlideshow.vue?vue&type=style&index=0&id=72a99711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a99711",
  null
  
)

export default component.exports